/**
 * Book/set cover image URL. Prefer API-signed URL (private bucket); fall back to direct S3.
 */
export function getCoverImageUrl(filename, signedUrl) {
  if (signedUrl) return signedUrl;
  if (!filename) return "";
  if (filename.startsWith("http://") || filename.startsWith("https://")) {
    return filename;
  }

  const bucket = process.env.REACT_APP_AWS_BUCKET_NAME;
  const region = process.env.REACT_APP_AWS_BUCKET_REGION || "ap-south-1";
  if (!bucket) return "";

  const key = filename.includes("/") ? filename : `books/${filename}`;
  return `https://${bucket}.s3.${region}.amazonaws.com/${key}`;
}

export function getBookFrontCoverUrl(book) {
  return getCoverImageUrl(book?.imageCoverFront, book?.imageCoverFrontUrl);
}

export function getBookBackCoverUrl(book) {
  return getCoverImageUrl(book?.imageCoverBack, book?.imageCoverBackUrl);
}

/** Resolve URL when main preview may show front or back */
export function getBookCoverUrlByKey(book, coverKey) {
  if (!book || !coverKey) return "";
  if (coverKey === book.imageCoverBack) {
    return getBookBackCoverUrl(book);
  }
  return getCoverImageUrl(coverKey, book.imageCoverFrontUrl);
}
